import React, { useEffect, useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import {
  GetTbsInfo,
  SubmitAboutUs,
  SubmitPrivacyPolicy,
  SubmitTermsConditions,
  SubmitUserAgreement,
} from "../../../Api/Settings/SystemSettings/LegalInformations";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { IoClose } from "react-icons/io5";
import { FaEye } from "react-icons/fa";
import { GoDownload } from "react-icons/go";
const AboutUs = ({isModalOpen,setIsModalOpen}) => {
  const dispatch = useDispatch();

  const legal_info = useSelector((state) => state?.crm?.tbs_info);
  console.log(legal_info?.terms_conditions, "about_us_info");
  const li_id = legal_info.id;
  console.log(li_id, "legal_info_id");
   const crud=sessionStorage.getItem("crud_permission")

  useEffect(() => {
    GetTbsInfo(dispatch);
  }, [dispatch]);

  // useEffect(() => {
  //     if (legal_info) {
  //         setAboutUs(legal_info?.about_us || '');
  //         setPrivacyPolicy(legal_info?.privacy_policy || '');
  //         setTermsConditions(legal_info?.terms_conditions || '');
  //         setUserAgreement(legal_info?.user_agreement || '');
  //     }
  // }, [legal_info]);

  const [aboutUs, setAboutUs] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [termsConditions, setTermsConditions] = useState("");
  const [userAgreement, setUserAgreement] = useState("");
  const [errors, setErrors] = useState({});
  const [buttonHover, setButtonHover] = useState("");
  const [abtIsEdit, setAbtIsEdit] = useState(false);
  const [pvcIsEdit, setPvcIsEdit] = useState(false);
  const [tmcIsEdit, setTmcIsEdit] = useState(false);
  const [useIsEdit, setUseIsEdit] = useState(false);

  console.log(aboutUs, "valueofaboutus");
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [isAboutUsValid, setIsAboutUsValid] = useState(false);

  const [fileContents, setFileContents] = useState({});

  const [uploadStatus, setUploadStatus] = useState({
    about_us: false,
    privacy_policy: false,
    terms_condition: false,
    user_agreement: false,
  });

  console.log(fileContents, "filecontnetabout_us");

  const openModal = (content, title) => {
    if ((content, title)) {
      setModalContent(content);
      setIsModalOpen(true);
      setModalTitle(title);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent("");
  };

  const validateFile = (file) => {
    if (!file) return "Please select a file.";
    if (file.size > 5 * 1024 * 1024) return "File size must be less than 2MB.";
    if (file.type !== "text/plain") return "Only .txt files are allowed.";
    return "";
  };

  // --------------------------------------------------Upload & Preview------------------------------------------------------------------------

  const handleFileChange = (event, key) => {
    const file = event.target.files[0];

    const validationError = validateFile(file);
    console.log(file, "selected_filess");
    setErrors((prevErrors) => ({
      ...prevErrors,
      [key]: validationError || "",
    }));

    // setter(validationError ? null : file);
    setIsAboutUsValid(!validationError);
    // console.log(setter, "setter_setter")
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileContents((prevContents) => ({
          ...prevContents,
          [key]: e.target.result,
        }));
      };

      reader.readAsText(file);

      setErrors((prevErrors) => ({
        ...prevErrors,
        [key]: "",
      }));

      setUploadStatus((prevStatus) => ({
        ...prevStatus,
        [key]: true,
      }));

      switch (key) {
        case "about_us":
          setAboutUs(file);
          break;
        case "privacy_policy":
          setPrivacyPolicy(file);
          break;
        case "terms_condition":
          setTermsConditions(file);
          break;
        case "user_agreement":
          setUserAgreement(file);
          break;
        default:
          console.warn("Unexpected key:", key);
          break;
      }

      event.target.value = null;
    }
  };

  const getFileName = (key) => {
    switch (key) {
      case "about_us":
        return legal_info.about_us ? "About Us.txt" : "Upload About Us.txt";
      case "privacy_policy":
        return legal_info.privacy_policy
          ? "Privacy Policy.txt"
          : "Upload Privacy Policy.txt";
      case "terms_conditions":
        return legal_info.terms_conditions
          ? "Terms and Conditions.txt"
          : "Upload Terms and Conditions.txt";
      case "user_agreement":
        return legal_info.user_agreement
          ? "User Agreement.txt"
          : "Upload User Agreement.txt";
      default:
        return "Upload file";
    }
  };

  // ---------------------------------------------------------------------------------SaveFunctionality-------------------------------------------------------

  const handleSave = async (file, key) => {
    // const validationError = validateFile(file);
    // setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     [key]: validationError,
    // }));
    // console.log(validationError, 'validation_error');

    // if (!validationError) {
    //     console.log(`${key} is valid and ready to be saved:`, file);
    // }
    console.log(file,"savebuttonfile");

    if(legal_info && file == ""){
      setAbtIsEdit(false);
      setPvcIsEdit(false);
      setTmcIsEdit(false);
      setUseIsEdit(false);
      // toast.success(`${key} content Updated successfully!`)
    }
    
else{

    const validationError = validateFile(file);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [key]: validationError,
    }));
    console.log(validationError, "validation_error");

    if (validationError) return;

    console.log(`${key} is valid and ready to be saved:`, file);

    if (file) {
      switch (key) {
        case "about_us":
          try {
            const data = await SubmitAboutUs(file, li_id);
            console.log(data, "about_us");
             toast.success("About Us Updated Successfully!");
            // setFileContents((prevContents) => ({
            //     ...prevContents,
            //     about_us: '',
            // }));
            setAboutUs("");
            setUploadStatus((prevStatus) => ({
              ...prevStatus,
              about_us: false,
            }));
            setAbtIsEdit(false);
          } catch (error) {
            console.error("Error uploading data", error);
          }
          break;

        case "privacy_policy":
          try {
            const data = await SubmitPrivacyPolicy(file, li_id);
            toast.success("Privacy Policy Updated Successfully!");
            // setFileContents((prevContents) => ({
            //     ...prevContents,
            //     privacy_policy: '',
            // }));
            setPrivacyPolicy("");
            setUploadStatus((prevStatus) => ({
              ...prevStatus,
              privacy_policy: false,
            }));
            setPvcIsEdit(false);
          } catch (error) {
            console.error("Error uploading data", error);
          }
          break;

        case "terms_condition":
          try {
            const data = await SubmitTermsConditions(file, li_id);
            toast.success("Terms and Conditions Updated Successfully!");
            // setFileContents((prevContents) => ({
            //     ...prevContents,
            //     terms_condition: '',
            // }));
            setTermsConditions("");

            setUploadStatus((prevStatus) => ({
              ...prevStatus,
              terms_condition: false,
            }));
            setTmcIsEdit(false);
          } catch (error) {
            console.error("Error uploading data", error);
          }
          break;

        case "user_agreement":
          try {
            const data = await SubmitUserAgreement(file, li_id);
            toast.success("User Agreement Updated Successfully");
            // setFileContents((prevContents) => ({
            //     ...prevContents,
            //     user_agreement: '',
            // }));
            setUserAgreement("");
            setUploadStatus((prevStatus) => ({
              ...prevStatus,
              user_agreement: false,
            }));
            setUseIsEdit(false);
          } catch (error) {
            console.error("Error uploading data", error);
          }
          break;

        default:
          console.warn(`No handler for key: ${key}`);
          break;
      }
    } else {
      return errors;
    }
  }
  };

  console.log(
    fileContents?.about_us?.trim(),
    fileContents?.privacy_policy?.trim(),
    fileContents?.terms_condition?.trim(),
    fileContents?.user_agreement?.trim(),
    "all_of_the_file_content"
  );

  // -------------------------------------------------------------------DownloadFunctionality---------------------------------------------------------------------

  const handleDownload = (key) => {
    let content = "";

    switch (key) {
      case "about_us":
        content = fileContents?.about_us
          ? fileContents?.about_us
          : legal_info?.about_us;
        break;
      case "privacy_policy":
        content = fileContents?.privacy_policy
          ? fileContents?.privacy_policy
          : legal_info?.privacy_policy;
        break;
      case "terms_conditions":
        content = fileContents?.terms_condition
          ? fileContents?.terms_condition
          : legal_info?.terms_conditions;
        break;
      case "user_agreement":
        content = fileContents?.user_agreement
          ? fileContents?.user_agreement
          : legal_info?.user_agreement;
        break;
      default:
        console.warn(`No content available for key: ${key}`);
        return;
    }

    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${key}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className="grid grid-rows-4 gap-[0.5vw] py-[1vw] pl-[6vw] pr-[6vw]">
        <div>
          <div className="flex">
            <p className="text-[1.25vw] text-[#1F487C] font-semibold">
              About Us
            </p>
            <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
          </div>
          <div className="grid grid-cols-12 gap-[4vw]">
            <div className="col-span-7">
              <div>
                <div className="relative mb-2">
                  <input
                    id="about_us"
                    type="file"
                    style={{ display: "none" }}
                    accept=".txt"
                    // onChange={(event) => handleFileChange(setAboutUs, 'about_us', event)}
                    onChange={(event) => {
                      handleFileChange(event, "about_us");
                      console.log( event, "filesfiles");
                    }}
                  />
                  <button
                    type="button"
                    className={` border-r-[0.25vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue  text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${
                      abtIsEdit === false
                        ? "cursor-not-allowed border-[#1f477c89]"
                        : "border-[#1F487C]"
                    }`}
                    disabled={abtIsEdit === false}
                    onClick={(event) => {
                      event.preventDefault();
                      document.getElementById("about_us").click();
                    }}
                  >
                    {aboutUs ? (
                      <div
                        className={`cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[1vw] ${
                          abtIsEdit === false
                            ? "text-[#1f477c89]"
                            : "text-[#1F487C]"
                        }`}
                      >
                        {aboutUs.name}
                      </div>
                    ) : (
                      <span className="text-[#1F487C] text-[0.9vw]">
                        {getFileName("about_us")}
                      </span>
                    )}
                    <FaCloudUploadAlt
                      color={abtIsEdit === false ? "#1f477c89" : "#1F487C"}
                      size={"2vw"}
                      className="absolute right-[1vw]"
                    />
                  </button>

                  {errors.about_us && (
                    <div
                      style={{ color: "red" }}
                      className="text-[0.8vw] absolute bottom-[-1.25vw]"
                    >
                      {errors.about_us}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-5">
              <div className="grid grid-cols-11 gap-[3vw]">
                <button
                  type="button"
                  // onClick={() => openModal(legal_info.about_us, 'About Us')}
                  onClick={() =>
                    openModal(
                      fileContents.about_us
                        ? fileContents.about_us
                        : legal_info.about_us,
                      "About Us"
                    )
                  }
                  onMouseEnter={() => {
                    setButtonHover("abt_rpl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "abt_rpl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <span className="mt-[0.1vw]">
                      <FaEye />
                    </span>
                    <div> Preview</div>
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => handleDownload("about_us")}
                  onMouseEnter={() => {
                    setButtonHover("abt_dwnl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "abt_dwnl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <div>
                      <GoDownload />
                    </div>
                    <span>Download</span>
                  </div>
                </button>

                {abtIsEdit === false ? (
                  <button
                    type="button"
                    disabled={crud?.includes("delete")||crud?.includes("create")||crud?.includes("view")}
                    className={`col-span-3 bg-[#1F487C] text-white  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${crud?.includes("delete")||crud?.includes("create")||crud?.includes("view")?"cursor-not-allowed":"cursor-pointer"}`}
                    onClick={() => setAbtIsEdit(true)}
                    onMouseEnter={() => {
                      setButtonHover("abt_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                  >
                    Edit
                  </button>
                ) : (
                  <button
                    type="button"
                    className={`col-span-3 bg-[#1F487C] text-white  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                    onClick={() => handleSave(aboutUs, "about_us")}
                    onMouseEnter={() => {
                      setButtonHover("abt_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                    // disabled={!uploadStatus.about_us}
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex">
            <p className="text-[1.25vw] text-[#1F487C] font-semibold">
              Privacy Policy
            </p>
            <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
          </div>
          <div className="grid grid-cols-12 gap-[4vw]">
            <div className="col-span-7">
              <div>
                <div className="relative mb-2">
                  <input
                    id="privacy_policy"
                    type="file"
                    style={{ display: "none" }}
                    accept=".txt"
                    // onChange={(event) => handleFileChange(setPrivacyPolicy, 'privacyPolicy', event)}
                    onChange={(event) =>
                      handleFileChange(event, "privacy_policy")
                    }
                  />
                  <button
                    type="button"
                    className={` border-r-[0.25vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue  text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${
                      pvcIsEdit === false
                        ? "cursor-not-allowed border-[#1f477c89]"
                        : "border-[#1F487C]"
                    }`}
                    disabled={pvcIsEdit === false}
                    onClick={(event) => {
                      event.preventDefault();
                      document.getElementById("privacy_policy").click();
                    }}
                  >
                    {privacyPolicy ? (
                      <div
                        className={`cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[1vw] ${
                          pvcIsEdit === false
                            ? "text-[#1f477c89]"
                            : "text-[#1F487C]"
                        }`}
                      >
                        {privacyPolicy.name}
                      </div>
                    ) : (
                      <span className="text-[#1F487C] text-[0.9vw]">
                        {" "}
                        {getFileName("privacy_policy")}
                      </span>
                    )}

                    <FaCloudUploadAlt
                      color={pvcIsEdit === false ? "#1f477c89" : "#1F487C"}
                      size={"2vw"}
                      className="absolute right-[1vw]"
                    />
                  </button>
                  {errors.privacy_policy && (
                    <div
                      style={{ color: "red" }}
                      className="text-[0.8vw] absolute bottom-[-1.25vw]"
                    >
                      {errors.privacy_policy}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-5">
              <div className="grid grid-cols-11 gap-[3vw]">
                <button
                  type="button"
                  // onClick={() => openModal(legal_info.privacy_policy, 'Privacy Policy')}
                  onClick={() =>
                    openModal(
                      fileContents.privacy_policy
                        ? fileContents.privacy_policy
                        : legal_info.privacy_policy,
                      "Privacy Policy"
                    )
                  }
                  onMouseEnter={() => {
                    setButtonHover("pyc_rpl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "pyc_rpl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <span className="mt-[0.1vw]">
                      <FaEye />
                    </span>
                    <div> Preview</div>
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => handleDownload("privacy_policy")}
                  onMouseEnter={() => {
                    setButtonHover("pyc_dwnl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "pyc_dwnl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <div>
                      <GoDownload />
                    </div>
                    <span>Download</span>
                  </div>
                </button>
                {pvcIsEdit === false ? (
                  <button
                    type="button"
                    disabled={crud?.includes("delete")||crud?.includes("create")||crud?.includes("view")}
                    className={`col-span-3 bg-[#1F487C] text-white  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${crud?.includes("delete")||crud?.includes("create")||crud?.includes("view")?"cursor-not-allowed":"cursor-pointer"}`}
                    onClick={() => setPvcIsEdit(true)}
                    onMouseEnter={() => {
                      setButtonHover("abt_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                  >
                    Edit
                  </button>
                ) : (
                  <button
                    type="button"
                    className={`col-span-3  bg-[#1F487C] text-white border-white border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                    onClick={() => handleSave(privacyPolicy, "privacy_policy")}
                    onMouseEnter={() => {
                      setButtonHover("pyc_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                    // disabled={!uploadStatus.privacy_policy}
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex">
            <p className="text-[1.25vw] text-[#1F487C] font-semibold">
              Terms and Conditions
            </p>
            <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
          </div>
          <div className="grid grid-cols-12 gap-[4vw]">
            <div className="col-span-7">
              <div>
                <div className="relative mb-2">
                  <input
                    id="terms_conditions"
                    type="file"
                    style={{ display: "none" }}
                    accept=".txt"
                    // onChange={(event) => handleFileChange(setTermsConditions, 'terms_conditions_upload', event)}
                    onChange={(event) =>
                      handleFileChange(event, "terms_condition")
                    }
                  />
                  <button
                    type="button"
                    className={` border-r-[0.25vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${
                      tmcIsEdit === false
                        ? "cursor-not-allowed border-[#1f477c89]"
                        : "border-[#1F487C]"
                    }`}
                    disabled={tmcIsEdit === false}
                    onClick={(event) => {
                      event.preventDefault();
                      document.getElementById("terms_conditions").click();
                    }}
                  >
                    {termsConditions ? (
                      <div
                        className={`cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[1vw] ${
                          tmcIsEdit === false
                            ? "text-[#1f477c89]"
                            : "text-[#1F487C]"
                        }`}
                      >
                        {termsConditions.name}
                      </div>
                    ) : (
                      <span className="text-[#1F487C] text-[0.9vw]">
                        {" "}
                        {getFileName("terms_conditions")}
                      </span>
                    )}

                    <FaCloudUploadAlt
                      color={tmcIsEdit === false ? "#1f477c89" : "#1F487C"}
                      size={"2vw"}
                      className="absolute right-[1vw]"
                    />
                  </button>
                  {/* {termsConditions && (
                                        <div className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.7vw]">
                                            {termsConditions.name}
                                        </div>
                                    )} */}
                  {errors.terms_condition && (
                    <div
                      style={{ color: "red" }}
                      className="text-[0.8vw] absolute bottom-[-1.25vw]"
                    >
                      {errors.terms_condition}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-5">
              <div className="grid grid-cols-11 gap-[3vw]">
                <button
                  type="button"
                  // onClick={() => openModal(legal_info.terms_conditions, 'Terms & Conditions')}
                  onClick={() =>
                    openModal(
                      fileContents.terms_condition
                        ? fileContents?.terms_condition
                        : legal_info?.terms_conditions,
                      "Terms & Condition"
                    )
                  }
                  onMouseEnter={() => {
                    setButtonHover("tmc_rpl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "tmc_rpl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <span className="mt-[0.1vw]">
                      <FaEye />
                    </span>
                    <div> Preview</div>
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => handleDownload("terms_conditions")}
                  onMouseEnter={() => {
                    setButtonHover("tmc_dwnl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "tmc_dwnl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <div>
                      <GoDownload />
                    </div>
                    <span>Download</span>
                  </div>
                </button>
                {tmcIsEdit === false ? (
                  <button
                    type="button"
                    disabled={crud?.includes("delete")||crud?.includes("create")||crud?.includes("view")}
                    className={`col-span-3 bg-[#1F487C] text-white  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${crud?.includes("delete")||crud?.includes("create")||crud?.includes("view")?"cursor-not-allowed":"cursor-pointer"}`}
                    onClick={() => setTmcIsEdit(true)}
                    onMouseEnter={() => {
                      setButtonHover("abt_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                  >
                    Edit
                  </button>
                ) : (
                  <button
                    type="button"
                    className={`col-span-3 bg-[#1F487C] text-white border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                    // onClick={() => openModal(fileContents.terms_condition ? fileContents.terms_condition : legal_info.terms_condition, 'About Us')}
                    onClick={() =>
                      handleSave(termsConditions, "terms_condition")
                    }
                    onMouseEnter={() => {
                      setButtonHover("tmc_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                    // disabled={!uploadStatus.terms_condition}
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex">
            <p className="text-[1.25vw] text-[#1F487C] font-semibold">
              User Agreement
            </p>
            <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
          </div>
          <div className="grid grid-cols-12 gap-[4vw]">
            <div className="col-span-7">
              <div>
                <div className="relative mb-2">
                  <input
                    id="user_agreement"
                    type="file"
                    style={{ display: "none" }}
                    accept=".txt"
                    onChange={(event) => {
                      handleFileChange(event, "user_agreement");
                    }}
                    // onChange={(event) => handleFileChange(setUserAgreement, 'user_agreement', event)}
                  />
                  <button
                    type="button"
                    className={` border-r-[0.25vw] relative flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${
                      useIsEdit === false
                        ? "cursor-not-allowed border-[#1f477c89]"
                        : "border-[#1F487C]"
                    }`}
                    disabled={useIsEdit === false}
                    onClick={(event) => {
                      event.preventDefault();
                      document.getElementById("user_agreement").click();
                    }}
                  >
                    {userAgreement ? (
                      <div
                        className={`cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[1vw] ${
                          useIsEdit === false
                            ? "text-[#1f477c89]"
                            : "text-[#1F487C]"
                        }`}
                      >
                        {userAgreement.name}
                      </div>
                    ) : (
                      <span className=" text-[#1F487C] text-[0.9vw]">
                        {" "}
                        {getFileName("user_agreement")}
                      </span>
                    )}

                    <FaCloudUploadAlt
                      color={useIsEdit === false ? "#1f477c89" : "#1F487C"}
                      size={"2vw"}
                      className="absolute right-[1vw]"
                    />
                  </button>
                  {/* {userAgreement && (
                                        <div className="cursor-pointer underline-offset-1 underline text-[#1F4B7F] text-[0.7vw]">
                                            {userAgreement.name}
                                        </div>
                                    )} */}
                  {errors.user_agreement && (
                    <div
                      style={{ color: "red" }}
                      className="text-[0.8vw] absolute bottom-[-1.25vw]"
                    >
                      {errors.user_agreement}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-5">
              <div className="grid grid-cols-11 gap-[3vw]">
                <button
                  type="button"
                  onClick={() =>
                    openModal(
                      fileContents.user_agreement
                        ? fileContents.user_agreement
                        : legal_info.user_agreement,
                      "User Agreement"
                    )
                  }
                  onMouseEnter={() => {
                    setButtonHover("usa_rpl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "usa_rpl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <span className="mt-[0.1vw]">
                      <FaEye />
                    </span>
                    <div> Preview</div>
                  </div>
                </button>
                <button
                  type="button"
                  onMouseEnter={() => {
                    setButtonHover("usa_dwnl");
                  }}
                  onMouseLeave={() => {
                    setButtonHover("");
                  }}
                  onClick={() => handleDownload("user_agreement")}
                  style={{
                    transition: "ease-in 0.1s",
                  }}
                  className={`col-span-4 ${
                    buttonHover === "usa_dwnl"
                      ? "bg-[#1F487C] text-white"
                      : "bg-white text-[#1F487C]"
                  }  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                >
                  <div className="flex justify-center items-center gap-[0.5vw]">
                    <div>
                      <GoDownload />
                    </div>
                    <span>Download</span>
                  </div>
                </button>

                {useIsEdit === false ? (
                  <button
                    type="button"
                    disabled={crud?.includes("delete")||crud?.includes("create")||crud?.includes("view")}
                    className={`col-span-3 bg-[#1F487C] text-white  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none ${crud?.includes("view")||crud?.includes("delete")||crud?.includes("create")?"cursor-not-allowed":"cursor-pointer"}`}
                    onClick={() => setUseIsEdit(true)}
                    onMouseEnter={() => {
                      setButtonHover("abt_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                  >
                    Edit
                  </button>
                ) : (
                  <button
                    type="button"
                    className={`col-span-3 bg-[#1F487C] text-white  border-r-[0.25vw] relative  px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]  text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                    // onClick={() => openModal(fileContents.user_agreement ? fileContents.user_agreement : legal_info.user_agreement, 'About Us')}
                    onClick={() => handleSave(userAgreement, "user_agreement")}
                    onMouseEnter={() => {
                      setButtonHover("usa_sve");
                    }}
                    onMouseLeave={() => {
                      setButtonHover("");
                    }}
                    // disabled={!uploadStatus.user_agreement}
                  >
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        {isModalOpen && (
  <div
    className="inset-0 bg-black bg-opacity-50 flex justify-center items-center fixed pointer-events-none z-50"
  >
    <div
      className="bg-white rounded-lg shadow-lg pb-[1vw] px-[0.5vw] border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] w-3/4 max-h-[75vh] overflow-y-auto pointer-events-auto"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-between px-[3vw] pt-[1vw] pb-[0.5vw]">
        <p className="order-first text-[#1F487C] text-[1.54vw] font-bold">
          {modalTitle} :
        </p>
        <button
          onClick={closeModal}
          className="order-last text-gray-500 text-lg float-right hover:bg-blue-100 hover:rounded-lg"
        >
          <IoClose size="2vw" color="#1F487C" />
        </button>
      </div>

      <div className="text-[#1F487C] font-serif w-full text-[1vw] pointer-events-auto">
        <div className="px-[3vw] py-[1vw]">
          {modalContent?.split("\r\n")?.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </div>
      </div>
    </div>
  </div>
)}

      </div>
    </>
  );
};

export default AboutUs;
